export default "__VITE_ASSET__Dt6_mjli__"